import NumberUtils from 'portaltransparencia-common/libs/NumberUtils.js';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';

import * as actions from './Actions.js';

export class FormTotalAcesso extends Component {
  static propTypes = {
    totalacesso: PropTypes.object.isRequired,
    findTotalAcesso: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { totalacesso, findTotalAcesso } = this.props;

    if (!totalacesso.has('totalAcessos')) {
      findTotalAcesso();
    }
  }

  render() {
    const { totalacesso } = this.props;

    return (
      <div>
        <i className="fa fa-user"></i>
        <label>
          Nº de acessos:{' '}
          {NumberUtils.formatMilhar(totalacesso.get('totalAcessos'))}
        </label>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    totalacesso: state.totalacesso.get('totalacesso')
  };
}

const allActions = {
  ...actions
};

export default connect(mapStateToProps, allActions)(FormTotalAcesso);
